import script from "./ConfigureActionCredentialsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureActionCredentialsDialog.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureActionCredentialsDialog.vue?vue&type=style&index=0&id=10abf159&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10abf159"]])

export default __exports__